// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.title-bar {
    background-color: #C6BB95;
    /*color: rgb(163, 131, 43);*/
    color: black;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /*font-family: "Sacramento", cursive; */
    font-family: "Euphoria Script", cursive;
    font-weight: 400;
    font-style: normal;
    border: 1px solid black; /* Frame border color */
    border-radius: 1px; /* Adjust this value to change the roundness of the corners */
  }

  .euk1 {
    width: 100px; /* Adjust the width of the logo as needed */
    height: 100px; /* Adjust the height of the logo as needed */
    margin-left: auto; /* Add margin between the logo and the text */
    transform: rotateY(180deg);
  }

  .euk2 {
    width: 100px; /* Adjust the width of the logo as needed */
    height: 100px; /* Adjust the height of the logo as needed */
    margin-right: 10px; /* Add margin between the logo and the text */
  }

  .uploadbutton {
          font-size: 24px;
          font-family: "Euphoria Script", cursive;
          font-weight: 400;
          font-style: normal;
  }

  .menu-icon {
    margin-left: auto; /* Push the menu icon to the right */
    margin-right: 40px;
    cursor: pointer;
    float: right;
              font-family: "Euphoria Script", cursive;
                        font-weight: 400;
                                  font-style: normal;
  }

  .menu-icon i {
    font-size: 24px; /* Adjust the size of the icon */
  }

  .menu {
  background-color: ivory;
  color: black;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.menu div {
  padding: 5px 0;
  cursor: pointer;
}

.menu div:hover {
  background-color: ivory;
}

/* Modal styles */
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    background-color: black;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    color: white;
    position: relative;
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: white;
    text-decoration: none;
    cursor: pointer;
  }

  `, "",{"version":3,"sources":["webpack://./src/Components/Titlebar.css"],"names":[],"mappings":";;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB,EAAE,uBAAuB;IAChD,kBAAkB,EAAE,6DAA6D;EACnF;;EAEA;IACE,YAAY,EAAE,2CAA2C;IACzD,aAAa,EAAE,4CAA4C;IAC3D,iBAAiB,EAAE,6CAA6C;IAChE,0BAA0B;EAC5B;;EAEA;IACE,YAAY,EAAE,2CAA2C;IACzD,aAAa,EAAE,4CAA4C;IAC3D,kBAAkB,EAAE,6CAA6C;EACnE;;EAEA;UACQ,eAAe;UACf,uCAAuC;UACvC,gBAAgB;UAChB,kBAAkB;EAC1B;;EAEA;IACE,iBAAiB,EAAE,oCAAoC;IACvD,kBAAkB;IAClB,eAAe;IACf,YAAY;cACF,uCAAuC;wBAC7B,gBAAgB;kCACN,kBAAkB;EAClD;;EAEA;IACE,eAAe,EAAE,gCAAgC;EACnD;;EAEA;EACA,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oCAAoC;EACtC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB","sourcesContent":["\r\n\r\n.title-bar {\r\n    background-color: #C6BB95;\r\n    /*color: rgb(163, 131, 43);*/\r\n    color: black;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /*font-family: \"Sacramento\", cursive; */\r\n    font-family: \"Euphoria Script\", cursive;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    border: 1px solid black; /* Frame border color */\r\n    border-radius: 1px; /* Adjust this value to change the roundness of the corners */\r\n  }\r\n\r\n  .euk1 {\r\n    width: 100px; /* Adjust the width of the logo as needed */\r\n    height: 100px; /* Adjust the height of the logo as needed */\r\n    margin-left: auto; /* Add margin between the logo and the text */\r\n    transform: rotateY(180deg);\r\n  }\r\n\r\n  .euk2 {\r\n    width: 100px; /* Adjust the width of the logo as needed */\r\n    height: 100px; /* Adjust the height of the logo as needed */\r\n    margin-right: 10px; /* Add margin between the logo and the text */\r\n  }\r\n\r\n  .uploadbutton {\r\n          font-size: 24px;\r\n          font-family: \"Euphoria Script\", cursive;\r\n          font-weight: 400;\r\n          font-style: normal;\r\n  }\r\n\r\n  .menu-icon {\r\n    margin-left: auto; /* Push the menu icon to the right */\r\n    margin-right: 40px;\r\n    cursor: pointer;\r\n    float: right;\r\n              font-family: \"Euphoria Script\", cursive;\r\n                        font-weight: 400;\r\n                                  font-style: normal;\r\n  }\r\n\r\n  .menu-icon i {\r\n    font-size: 24px; /* Adjust the size of the icon */\r\n  }\r\n\r\n  .menu {\r\n  background-color: ivory;\r\n  color: black;\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.menu div {\r\n  padding: 5px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu div:hover {\r\n  background-color: ivory;\r\n}\r\n\r\n/* Modal styles */\r\n.modal {\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 1;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n  }\r\n\r\n  .modal-content {\r\n    background-color: black;\r\n    margin: 15% auto;\r\n    padding: 20px;\r\n    border: 1px solid #888;\r\n    width: 80%;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .close {\r\n    color: #aaa;\r\n    float: right;\r\n    font-size: 28px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .close:hover,\r\n  .close:focus {\r\n    color: white;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
